module.exports = __webpack_public_path__ + "img/fda.32676172.png";